import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

// declare var google: any;

@Component({
  selector: 'app-playback',
  templateUrl: './playback.component.html',
  styleUrls: ['./playback.component.scss']
})
export class PlaybackComponent implements AfterViewInit {
  @ViewChild('mapElement') mapElement: ElementRef;

  map: google.maps.Map;
  marker: google.maps.Marker;
  sliderValue = 0;
  location_timeanddate:any;
  // Replace this with your actual data
  locations = [
   
    
      // { lat: 28.40088984082893, lng: 77.3059689923795, timestamp: '2023-09-24 08:00:00' },
      // { lat: 28.4008331070187, lng: 77.30609401015448, timestamp: '2023-09-24 08:15:00' },
      // { lat: 28.400776373202347, lng: 77.30621902792334, timestamp: '2023-09-24 08:30:00' },
      // { lat: 28.400719639379862, lng: 77.3063440456861, timestamp: '2023-09-24 08:45:00' },
      // { lat: 28.400662905551244, lng: 77.30646906344265, timestamp: '2023-09-24 09:00:00' },
      // { lat: 28.40060617171649, lng: 77.30659408119299, timestamp: '2023-09-24 09:15:00' },
      // { lat: 28.4005494378756, lng: 77.30671909893712, timestamp: '2023-09-24 09:30:00' },
      // { lat: 28.40049270402858, lng: 77.30684411667403, timestamp: '2023-09-24 09:45:00' },
      // { lat: 28.40043597017543, lng: 77.30696913440574, timestamp: '2023-09-24 10:00:00' },
      // { lat: 28.40037923631616, lng: 77.30709415213022, timestamp: '2023-09-24 10:15:00' },
      // { lat: 28.40032250245075, lng: 77.3072191698485, timestamp: '2023-09-24 10:30:00' },
      // { lat: 28.400265768579206, lng: 77.30734418756055, timestamp: '2023-09-24 10:45:00' },
      // { lat: 28.40020903470153, lng: 77.30746920526639, timestamp: '2023-09-24 11:00:00' },
      // { lat: 28.400152300817724, lng: 77.307594222965, timestamp: '2023-09-24 11:15:00' },
      // { lat: 28.400095566927787, lng: 77.30771924065838, timestamp: '2023-09-24 11:30:00' },
      // { lat: 28.400038833031716, lng: 77.30784425834455, timestamp: '2023-09-24 11:45:00' },
      // { lat: 28.399982099129512, lng: 77.3079692760255, timestamp: '2023-09-24 12:00:00' },
      // { lat: 28.399925365221176, lng: 77.30809429369923, timestamp: '2023-09-24 12:15:00' },
      // { lat: 28.399868631306707, lng: 77.30821931136775, timestamp: '2023-09-24 12:30:00' },
      // { lat: 28.399811897386104, lng: 77.30834432903105, timestamp: '2023-09-24 12:45:00' },
      // { lat: 28.399755163459368, lng: 77.30846934668914, timestamp: '2023-09-24 13:00:00' },
      // { lat: 28.399698429526498, lng: 77.30859436434201, timestamp: '2023-09-24 13:15:00' },
      // { lat: 28.399641695587497, lng: 77.30871938198966, timestamp: '2023-09-24 13:30:00' },
      // { lat: 28.399698429526498, lng: 77.30859436434201, timestamp: '2023-09-24 13:45:00' },
      // { lat: 28.399755163459368, lng: 77.30846934668914, timestamp: '2023-09-24 14:00:00' },
      // { lat: 28.399811897386104, lng: 77.30834432903105, timestamp: '2023-09-24 14:15:00' },
      // { lat: 28.399868631306707, lng: 77.30821931136775, timestamp: '2023-09-24 14:30:00' },
    // Add more locations...
        { lat: 28.75838819223334, lng: 77.19474652522977, timestamp: '2023-09-24 08:00:00' },
      { lat: 28.76193138775358, lng: 77.18673513124632, timestamp: '2023-09-24 08:15:00' },
      { lat: 28.766550015628624,  lng: 77.18262117217373, timestamp: '2023-09-24 08:30:00' },
      { lat: 28.783504321702427, lng: 77.17995070756805, timestamp: '2023-09-24 08:45:00' },
      { lat: 28.78635085660346, lng: 77.18760122794866, timestamp: '2023-09-24 09:00:00' },
      { lat: 28.78616109002733, lng: 77.19474652528527, timestamp: '2023-09-24 09:15:00' },
      { lat: 28.780605217652525, lng:  77.20100103344859, timestamp: '2023-09-24 09:30:00' },
      { lat: 28.775617610369807,  lng: 77.2045224646185, timestamp: '2023-09-24 09:45:00' },
      { lat: 28.769623219537,  lng: 77.2072273318041, timestamp: '2023-09-24 10:00:00' },
      { lat: 28.76125733751143,  lng:77.21136118578536, timestamp: '2023-09-24 10:15:00' },
  ];

  animationInterval: any;
  animationSpeed = 100; // Adjust animation speed in milliseconds
  ngAfterViewInit() {
    const mapProperties = {
      center: new google.maps.LatLng(this.locations[0].lat, this.locations[0].lng),
      zoom: 15, // Adjust the zoom level as needed
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      travelMode: google.maps.TravelMode.TWO_WHEELER,
      provideRouteAlternatives: false,
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);
  
    // Create a LatLng array for the polyline
    const pathCoordinates = this.locations.map(location => new google.maps.LatLng(location.lat, location.lng));
    const directionsService = new google.maps.DirectionsService();
  
    const path = new google.maps.Polyline({
      path: pathCoordinates,
      geodesic: true,
      strokeColor: '#090de0',
      strokeOpacity: 5,
      strokeWeight: 5
     
    });
  
    path.setMap(this.map);
  
    // Create a marker for the mover (animated marker) at the start location
    this.marker = new google.maps.Marker({
      position: this.locations[0],
      map: this.map,
      animation: google.maps.Animation.DROP // Marker drop animation
    });
    this.marker.setIcon('./assets/location/mover.png');
    this.location_timeanddate=this.locations[0].timestamp
    // Create a marker for the start location
    const startMarker = new google.maps.Marker({
      position: this.locations[0],
      map: this.map
    });
    startMarker.setIcon('./assets/location/start_point.png'); // Replace with your start marker icon
  
    // Create a marker for the end location (last location in the array)
    const endMarker = new google.maps.Marker({
      position: this.locations[this.locations.length - 1],
      map: this.map
    });
    endMarker.setIcon('./assets/location/end_point.png'); // Replace with your end marker icon
  }
  

  onSliderChange(event: any) {
    const locationIndex = event.target.value;
    
    this.moveMarkerSmoothly(locationIndex);
    this.location_timeanddate=this.locations[locationIndex].timestamp
  }
  
  moveMarkerSmoothly(locationIndex: number) {
    // Clear the previous animation interval
    clearInterval(this.animationInterval);
  
    const startTime = performance.now();
    const startLocation = this.marker.getPosition();
    const endLocation = new google.maps.LatLng(
      this.locations[locationIndex].lat,
      this.locations[locationIndex].lng
    );
  
    const duration = 90; // Adjust the animation duration (in milliseconds) as needed
  
    this.animationInterval = setInterval(() => {
      const elapsedTime = performance.now() - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const newPosition = google.maps.geometry.spherical.interpolate(
        startLocation,
        endLocation,
        progress
      );
      this.marker.setPosition(newPosition);
   
      if (progress === 1) {
        clearInterval(this.animationInterval);
      }
    }, 10); // Adjust the animation frame rate (in milliseconds) as needed
  }
}
